'use strict';

var $ = require('jquery');
var util = require('../../utils/util');
var wishlist = require('../wishlist');
var addToCart = require('./addToCart');
var availability = require('./availability');
var image = require('./image');
var productNav = require('./productNav');
var productSet = require('./productSet');
var jumpMark = require('./jumpMark');
var recommendations = require('./recommendations');
var variant = require('./variant');
var deliveryEstimate = require('../../components/checkout/estimatedelivery');
var afterpayFlyin = require('../../components/checkout/afterpayFlyin');
var tabbyInfoFlyin = require('../../productdetail/tabbyinfoflyin');
const fitguide = require('../../components/product/fitguide');
const googlepay = require('../checkout/googlepay_ui');
const applePay = require('../checkout/applepay_ui');
const tracking = require('../../components/tracking/tracking');
const fitPredictor = require('../../components/fit-predictor');
const optiExperiment = require('../../components/optimizelyExperimentation');
const {handleCustomError} = require('../../utils/contentSquareHandler');

// ** B2B declarations
var quantityMulti = require('./quantityMulti');
// **

var product;

/**
 * @description Initialize optimizely experimentation on product detail page.
 */
async function initializeExperimentation() {
    const result = await optiExperiment.decideFeatureFlagVariation('pdp');
    if (result.variationKeyMobileImageTextOrder === 'treatment_1') {
        $('.pdp-main').addClass('m-text-above-image');
    } else if (result.variationKeyMobileImageTextOrder === 'treatment_2') {
        $('.pdp-main').addClass('m-image-above-text');
    }
}

/**
 * @description Initialize product detail page with reviews, recommendation and product navigation.
 */
function initializeDom() {
    productNav();
    recommendations();
    if (
        SitePreferences.isB2BSite &&
        $('#product-description .b2b-downloads').length &&
        $('.product-description-list').length
    ) {
        $('#product-description .b2b-downloads').appendTo('.product-description-list:last');
        $('#product-description .b2b-downloads').removeClass('hidden');
    }
}

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
    const $pdpMain = $('#pdpMain');
    const $applePayError = $('#apple-pay-pdp-button .error-form');
    const isOutOfStock = $pdpMain.find('.availability-msg').find('.not-available-msg').length == 1;

    addToCart();
    availability();
    variant();
    image();
    productSet();
    jumpMark.init();
    wishlist.init(true);
    afterpayFlyin.init();
    tabbyInfoFlyin.init();
    addToCart.updateAddToCartButtonState(false, true);
    fitPredictor.init('pdp');
    optiExperiment.trackEvent('pdp_visit');

    if (!fitguide.isInitialized() && $pdpMain.find('.flyin-product-info-fit-guide').length > 0) {
        fitguide.init();
    }

    deliveryEstimate.init(); //Include Narvar estimate delivery form handling events

    if (SitePreferences.isB2BSite) {
        quantityMulti.init();
    }

    // if (SitePreferences.STORE_PICKUP) {
    //     productStoreInventory.init();
    // }

    // Add to Wishlist and Add to Gift Registry links behaviors
    $pdpMain.on('click', '[data-action="wishlist"], [data-action="gift-registry"]', function () {
        var data = util.getQueryStringParams($('.pdpForm').serialize());
        var url;
        if (data.cartAction) {
            delete data.cartAction;
        }
        url = util.appendParamsToUrl(this.href, data);
        this.setAttribute('href', url);
    });

    if (sessionStorage.getItem('signInToBuyLogin') === 'true' && sessionStorage.getItem('signInToBuyProduct') != '') {
        var pid = sessionStorage.getItem('signInToBuyProduct');
        sessionStorage.removeItem('signInToBuyLogin');
        sessionStorage.removeItem('signInToBuyProduct');
        addToCart.addProductAfterLogin(pid);
    }

    // if the user just created their account - send an event to dataLayer
    if (sessionStorage.getItem('regSource') && sessionStorage.getItem('regSource') != '') {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'myAccountSignup',
                myAccountSignupStep: sessionStorage.getItem('regSource')
            });
        }
        sessionStorage.removeItem('regSource');
    }

    // product options
    $pdpMain.on('change', '.product-options select', function () {
        var $salesPrice = $pdpMain.find('.product-add-to-cart .price-sales');
        var $selectedItem = $(this).children().filter(':selected').first();
        $salesPrice.text($selectedItem.data('combined'));
    });

    // prevent default behavior of thumbnail link and add this Button
    $pdpMain.on('click', '.thumbnail-link, .unselectable a', function (e) {
        e.preventDefault();
    });

    //Include Narvar estimate delivery form handling events
    deliveryEstimate.init();

    $(document).ready(function () {
        if ($applePayError.length) {
            document.getElementById('add-to-cart').scrollIntoView();
        }
    });

    const googlePayContainer = document.getElementById('googlepay-wrapper');
    if (googlePayContainer) {
        googlepay.init();
    }

    // Updates availability reminder link state
    const isMissingSize = $('.js-product-sizes').data('is-missing-size');
    $('.product-reminder-trigger').toggleClass('hidden', !isMissingSize);

    // Remove the <isapplepay> tag, which is not a valid HTML element, if ApplePay is not available
    if (!applePay.isApplePaySession()) {
        $('#apple-pay-pdp-button').remove();
    }

    if (isOutOfStock) {
        handleCustomError('Product is out of stock', 'pdpError');
    }
}

product = {
    initializeEvents: initializeEvents,
    init: function () {
        initializeExperimentation();
        initializeDom();
        initializeEvents();
        tracking.initialDatalayerPush();
    }
};

module.exports = product;
